import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles( theme => ({
    fieldGroup: {
        // border: "1px solid black",
        // borderRadius: 10,
        // margin: '0.3rem'
    },
    // 'beneficiaryDOB': {
    //     [theme.breakpoints.up('xl')]: {
    //         marginLeft: "36vw"
    //     },
    //     [theme.breakpoints.down('lg')]: {
    //         marginLeft: "0"
    //     }
    // },
    // 'orSep': {
    //     [theme.breakpoints.down('lg')]: {
    //         marginLeft: '25vw'
    //     },
    //     [theme.breakpoints.down('md')]: {
    //         marginLeft: '5vw'
    //     }
    // }

}))

export default useStyles